import { clientDataService } from "../config/axios"


export const getDashboard = async () =>{
  return await clientDataService({
    url: `/api/dashboard/my`,
    method: "GET"
  })
}
